import { Link } from 'react-router-dom'

const Afip = () => {
   return (
      <>
         <div className="section animated fadeIn">
            {/* TÍTULO DE LA SECCIÓN */}
            <div className="row mb-title center mb-4">
               <div className="col s12 m12 l12 x12">
                  <h4 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600' }}>
                     ADMINISTRACIÓN FEDERAL DE INGRESOS PÚBLICOS
                  </h4>
               </div>
            </div>

            {/* TARJETA CONTENEDORA */}
            <div className="row justify-content-center">
               <div className="col s12 m12 l12">
                  <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '30px' }}>
                     
                     {[
                        {
                           titulo: 'Resolución General 3487',
                           url: 'http://servicios.infoleg.gob.ar/infolegInternet/anexos/210000-214999/212006/norma.htm'
                        },
                        {
                           titulo: 'Resolución General 2192',
                           url: 'http://servicios.infoleg.gob.ar/infolegInternet/anexos/200000-204999/200466/norma.htm'
                        },
                        {
                           titulo: 'Ley 27.401',
                           url: 'http://servicios.infoleg.gob.ar/infolegInternet/anexos/295000-299999/296846/norma.htm'
                        },
                        {
                           titulo: 'Resolución General 2812/10',
                           url: 'http://biblioteca.afip.gob.ar/dcp/REAG01002812_2010_04_21'
                        },
                        {
                           titulo: 'Resolución ANSES 130/10',
                           url: 'http://servicios.infoleg.gob.ar/infolegInternet/anexos/160000-164999/164680/norma.htm'
                        },
                        {
                           titulo: 'Resolución 2407/08',
                           url: 'http://servicios.infoleg.gob.ar/infolegInternet/anexos/135000-139999/137353/norma.htm'
                        },
                        {
                           titulo: 'Resolución 1891/05',
                           url: 'http://servicios.infoleg.gob.ar/infolegInternet/anexos/105000-109999/106744/texact.htm'
                        }
                     ].map((item, idx, arr) => (
                        <div 
                           key={idx} 
                           className="row valign-wrapper" 
                           style={{ 
                              display: 'flex', 
                              alignItems: 'center', 
                              marginBottom: idx === arr.length - 1 ? '0' : '18px', 
                              paddingBottom: idx === arr.length - 1 ? '0' : '18px', 
                              borderBottom: idx === arr.length - 1 ? 'none' : '1px solid #e0e0e0' 
                           }}
                        >
                           <div className="col s8 m9 l10">
                              <h6 className="grey-text text-darken-3" style={{ fontWeight: '600', margin: '0', fontSize: '1.05rem' }}>
                                 {item.titulo}
                              </h6>
                           </div>
                           <div className="col s4 m3 l2 center-align">
                              <Link 
                                 to={item.url} 
                                 target="_blank" 
                                 rel="noopener noreferrer" 
                                 className="btn waves-effect waves-light light-blue accent-3 z-depth-0" 
                                 style={{ borderRadius: '4px', textTransform: 'none', width: '100%' }}
                              >
                                 Ver
                                 <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '5px' }}>visibility</i>
                              </Link>
                           </div>
                        </div>
                     ))}

                  </div>
               </div>
            </div>

         </div>
      </>
   )
}

export default Afip